if (!customElements.get("ff-slider")) {
  class FFSlider extends HTMLElement {
    constructor() {
      super();
      this.ffSwiperInstance = null;
    }

    connectedCallback(){
      this.ffInitElements();
      this.ffSetConfig();
      this.ffHandleLayout();
    }

    ffInitElements() {
      this.ffSwiperEl = this.querySelector(".swiper");
      if (!this.ffSwiperEl) return;

      this.ffWrapper = this.ffSwiperEl.querySelector(".swiper-wrapper");
      this.ffSwiperPagination = this.ffSwiperEl.querySelector(".swiper-pagination");
      this.ffNextEl = this.querySelector(".swiper-button-next");
      this.ffPrevEl = this.querySelector(".swiper-button-prev");
    }

    ffSetConfig() {
      this.ffBreakpoint = parseInt(this.dataset.ffBreakpoint) || 768;
      this.ffIsMobile = window.innerWidth <= this.ffBreakpoint;

      this.ffLayout = this.ffGetLayout();
      this.ffItemsPerView = this.ffGetItemsPerView();
      this.ffShowArrows = this.ffGetShowArrows();
      this.ffShowDots = this.ffGetShowDots();
      this.ffSpaceBetween = this.ffGetSpaceBetween();

      this.ffAutoplay = this.dataset.ffAutoplay === "true";
      this.ffDelay = parseInt(this.dataset.ffDelay) || 3000;
      this.ffLoop = this.dataset.ffLoop === "true";
      this.ffSliderType = this.dataset.ffSliderType || "default";
      this.ffDirection = this.ffGetDirection();
    }

    ffGetLayout() {
      return (this.ffIsMobile 
        ? this.dataset.ffLayoutMobile 
        : this.dataset.ffLayoutDesktop) || "ff_slider";
    }

    ffGetItemsPerView() {
      const viewKey = this.ffIsMobile ? "ffItemsPerViewMobile" : "ffItemsPerViewDesktop";
      return parseFloat(this.dataset[viewKey]) || 'auto';
    }

    ffGetShowArrows() {
      return (this.ffIsMobile
        ? this.dataset.ffShowArrowsMobile
        : this.dataset.ffShowArrowsDesktop) || "true";
    }

    ffGetShowDots() {
      const val = this.ffIsMobile
        ? this.dataset.ffShowDotsMobile
        : this.dataset.ffShowDotsDesktop;
      return val !== "false";
    }

    ffGetSpaceBetween() {
      return (this.ffIsMobile 
        ? this.dataset.ffSpaceBetweenMobile
        : this.dataset.ffSpaceBetweenDesktop) || 0;
    }

    ffGetDirection = () => {
      return (this.ffIsMobile 
        ? this.dataset.ffDirectionMobile
        : this.dataset.ffDirectionDesktop) || "";
    }

    ffHandleLayout() {
      if (this.ffLayout === "ff_slider") {
        this.ffCreateSlider();
      } else {
        this.ffCreateGrid();
      }
    }

    ffCreateGrid() {
      if (!this.ffWrapper) return;

      this.ffWrapper.style.display = "flex";
      this.ffWrapper.style.flexWrap = "wrap";
      this.ffWrapper.style.gap = `${this.ffSpaceBetween}px`;

      const percentageWidth = (100 / this.ffItemsPerView);
      const gapSubtraction = (this.ffSpaceBetween * (this.ffItemsPerView - 1) / this.ffItemsPerView);

      Array.from(this.ffWrapper.children).forEach((child) => {
        child.style.width = `calc(${percentageWidth}% - ${gapSubtraction}px)`; 
        child.style.boxSizing = 'border-box';
      });
    }

    ffCreateSlider() {
      if (this.ffSwiperInstance || !this.ffWrapper || this.ffWrapper.children.length <= 1) return;

      const ffSliderOptions = this.ffConfigureSliderOptions();
      this.ffSwiperInstance = new Swiper(this.ffSwiperEl, ffSliderOptions);
    }

    ffConfigureSliderOptions() {
      const ffSliderOptions = {
        slidesPerView: this.ffItemsPerView,
        spaceBetween: this.ffSpaceBetween,
      }

      if (this.ffShowArrows === "true") {
        ffSliderOptions.navigation = {
          nextEl: this.ffNextEl,
          prevEl: this.ffPrevEl,
        }
      }

      if (this.ffShowDots) {
        ffSliderOptions.pagination = {
          el: this.ffSwiperPagination,
          clickable: true
        }
      }

      if (this.ffAutoplay) {
        ffSliderOptions.autoplay = {
          delay: this.ffDelay
        }
      }

      if (this.ffLoop) {
        ffSliderOptions.loop = this.ffLoop;
      }

      if (this.ffSliderType === "thumbs") {
        ffSliderOptions.watchSlideProgress = true;
        ffSliderOptions.slidesOffsetAfter = 10;
      }

      else if (this.ffSliderType == "main") {
        const ffMainSlider = this.parentElement.querySelector('[data-ff-slider-type="thumbs"]');
        const ffMainSliderSwiperInstace = ffMainSlider.ffSwiperInstance; 

        ffSliderOptions.thumbs = {
          swiper: ffMainSliderSwiperInstace
        }

        ffSliderOptions.on = {
          afterInit: (swiper) => {
            ffSliderOptions.thumbs.swiper.params.slideToClickedSlide = true;
            ffSliderOptions.thumbs.swiper.update();
          },
          realIndexChange: (swiper) => {
            ffSliderOptions.thumbs.swiper.slideToLoop(swiper.realIndex);
          },
        }
      }

      if (this.ffDirection !== "") {
        ffSliderOptions.direction = this.ffDirection;
      }
      
      return ffSliderOptions;
    }
  }

  customElements.define('ff-slider', FFSlider);
}
